<script lang="ts">
  export let value :string;
  import _ from "lodash";

  let _value = value;

  const onChange = _.debounce((_event :any) => {
    value = _value;
  }, 300);

</script>

<input
  bind:value={_value}
  class="input"
  placeholder="Quick search"
  on:input={onChange} />
